import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { AuditLog } from '../model/audit-log';

import * as _ from 'lodash';
import { SelectedOptionRevision } from '../model/selected-option-revision';

@Injectable()
export class AuditHistoryService {
  private baseUrl;
  private _auditLogCache: AuditLog[];
  private _selectedOptionRevisionCache: SelectedOptionRevision[];

  showQuoteHistoryModal$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private _http: AuthenticatedHttpService) {
    this.baseUrl = _http.getBaseURLFromCookie();
  }

  /// Gets the Audit History for a Quote
  getAuditHistory(quoteId: number, tableName: string): Observable<AuditLog[]> {
    return this._http
      .get(`${this.baseUrl}/api/audit/${quoteId}/${tableName}`)
      .map(x => {
        this._auditLogCache = x.json();
        return this._auditLogCache;
      })
      .catch(this._http.handleError);
  }

  /// Gets the Audit History for a Quote by RevisionNumber
  getAuditHistoryByRevisionNumber(
    quoteId: number,
    revisionNumber: number
  ): Observable<AuditLog[]> {
    return this._http
      .get(`${this.baseUrl}/api/audit/${quoteId}/${revisionNumber}/revisions`)
      .map(x => {
        this._auditLogCache = x.json();
        return this._auditLogCache;
      })
      .catch(this._http.handleError);
  }

  /// Gets the Audit History for a Quote by RevisionNumber
  getSelectedOptionLogByRevisionNumber(
    quoteId: number,
    revisionNumber: number
  ): Observable<SelectedOptionRevision[]> {
    return this._http
      .get(`${this.baseUrl}/api/audit/${quoteId}/${revisionNumber}/selectedoptionrevisions`)
      .map(x => {
        this._selectedOptionRevisionCache = x.json();
        return this._selectedOptionRevisionCache;
      })
      .catch(this._http.handleError);
  }

  // TODO: REMOVE, NO LONGER WILL BE USED
  /// Gets the Audit History for a Quote by multiple RevisionNumbers
  getAuditHistoryByRevisionNumbers(quoteId: number, revisionNumbers: number[]) {
    const firstData = this.getAuditHistoryByRevisionNumber(
      quoteId,
      revisionNumbers[0]
    );
    const secondData = this.getAuditHistoryByRevisionNumber(
      quoteId,
      revisionNumbers[1]
    );
    const firstSelectedOptions = this.getSelectedOptionLogByRevisionNumber(
      quoteId,
      revisionNumbers[0]
    );
    const secondSelectedOptions = this.getSelectedOptionLogByRevisionNumber(
      quoteId,
      revisionNumbers[1]
    );
    return combineLatest(
      firstData,
      secondData,
      firstSelectedOptions,
      secondSelectedOptions
    );
  }

  /// Gets users who have edited a specific revision
  getRevisionUsersByRevisionNumber(
    quoteId: number,
    revisionNumber: number
  ): Observable<any> {
    return this._http
      .get(
        `${
          this.baseUrl
        }/api/audit/${quoteId}/${revisionNumber}/revisionuserlist`
      )
      .map(res => {
        this._auditLogCache = res.json();
        return this._auditLogCache;
      })
      .catch(this._http.handleError);
  }

  /// Gets editors from multiple revisions
  getRevisionUsersFromMultipleRevisions(
    quoteId: number,
    revisionNumbers: number[]
  ) {
    const firstRevisionUsers = this.getRevisionUsersByRevisionNumber(
      quoteId,
      revisionNumbers[0]
    );
    const secondRevisionUsers = this.getRevisionUsersByRevisionNumber(
      quoteId,
      revisionNumbers[1]
    );
    return combineLatest(firstRevisionUsers, secondRevisionUsers);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/audit-history.service.ts